module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"header\">\n<div class=\"nav\">\n<div class=\"nav-buttons\">\n<button data-action=\"previous\"><i class=\"fi fi-angle-left\"></i></button>\n<button data-action=\"next\"><i class=\"fi fi-angle-right\"></i></button>\n</div>\n<div class=\"title\"><%- model.header.title; %></div>\n<div class=\"period-buttons\">\n<%\nif(model.showPeriodSelection !== false){\n%>\n<button data-action=\"day\" class=\"<%=((model.viewPeriod === \"day\" ? \" active\" : \"\"))%>\">Tag</button>\n<button data-action=\"week\" class=\"<%=((model.viewPeriod === \"week\" ? \" active\" : \"\"))%>\">Woche</button>\n<button data-action=\"month\" class=\"<%=((model.viewPeriod === \"month\" ? \" active\" : \"\"))%>\">Monat</button>\n<%\n}\n%>\n</div>\n</div>\n<div class=\"col-heads\">\n<%\t// build columns heads for calendar grid\nmodel.header.colHeads.forEach(function(title) {\t%>\n<div><div><%= title; %></div></div>\n<% }); %>\n</div>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/scheduler/header.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"header\">\n<div class=\"nav\">\n<div class=\"nav-buttons\">\n<button data-action=\"previous\"><i class=\"fi fi-angle-left\"></i></button>\n<button data-action=\"next\"><i class=\"fi fi-angle-right\"></i></button>\n</div>\n<div class=\"title\">")
    ; __line = 7
    ; __append( model.header.title )
    ; __append("</div>\n<div class=\"period-buttons\">\n")
    ; __line = 9
    ; 
if(model.showPeriodSelection !== false){

    ; __line = 11
    ; __append("\n<button data-action=\"day\" class=\"")
    ; __line = 12
    ; __append(escapeFn(((model.viewPeriod === "day" ? " active" : ""))))
    ; __append("\">Tag</button>\n<button data-action=\"week\" class=\"")
    ; __line = 13
    ; __append(escapeFn(((model.viewPeriod === "week" ? " active" : ""))))
    ; __append("\">Woche</button>\n<button data-action=\"month\" class=\"")
    ; __line = 14
    ; __append(escapeFn(((model.viewPeriod === "month" ? " active" : ""))))
    ; __append("\">Monat</button>\n")
    ; __line = 15
    ; 
}

    ; __line = 17
    ; __append("\n</div>\n</div>\n<div class=\"col-heads\">\n")
    ; __line = 21
    ; 	// build columns heads for calendar grid
model.header.colHeads.forEach(function(title) {	
    ; __line = 22
    ; __append("\n<div><div>")
    ; __line = 23
    ; __append(escapeFn( title ))
    ; __append("</div></div>\n")
    ; __line = 24
    ;  }); 
    ; __append("\n</div>\n</div>")
    ; __line = 26
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/scheduler/header.ejs

}